import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=9f1be438&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1be438",
  null
  
)

export default component.exports